// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
import { propType } from 'graphql-anywhere';
import Truncate from 'react-truncate';
// ANTD
import Table from 'antd/lib/table';
import Button from 'antd/lib/button';
import Icon from 'antd/lib/icon';
// APOLLO
import sessionFragment from 'ApolloClient/Fragments/sessionFragment';
// MOUDULES
import GeneralHelpers from 'lib/helpers/GeneralHelpers';
// COMPONENTS
import DeleteButton from 'components/common/DeleteButton';

const columns = ({ onEdit, showCols }) => {
  // List of available columns
  const cols = {
    title: {
      title: 'TITLE',
      dataIndex: 'title',
      key: 'title',
    },
    description: {
      title: 'DESCRIPTION',
      dataIndex: 'description',
      key: 'description',
      // width: 200,
      render: (text, record) => (
        <Truncate lines={2} ellipsis={<span>...</span>}>
          {(record && record.description) || ''}
        </Truncate>
      ),
    },
    category: {
      title: 'CATEGORY',
      dataIndex: 'sessionType.title',
    },
    date: {
      title: 'DATE',
      dataIndex: 'sessionDate',
      key: 'sessionDate',
      render: (text, record) => {
        if (record && record.sessionDate) {
          return <div>{GeneralHelpers.formatTableDate(record.sessionDate, 'utc') || ''}</div>;
        }
        return null;
      },
    },
    time: {
      title: 'TIME',
      dataIndex: 'sessionTime',
      key: 'sessionTime',
      render: (text, record) => (
        <div>
          {(record && record.sessionTime) || ''}
          {/* (record && record.sessionTime && MomentHelpers.formatHourTime(record.sessionTime)) || '' */}
        </div>
      ),
    },
    client: {
      title: 'CLIENT',
      dataIndex: 'client',
      key: 'client._id',
      render: (text, record) => (
        <div>
          {(record && record.client && record.client.firstName) || ''}
          &nbsp;
          {(record && record.client && record.client.lastName) || ''}
        </div>
      ),
    },
    edit: {
      title: 'EDIT',
      render: (text, record) => (
        <Button onClick={() => onEdit(record)}>
          <Icon type="edit" />
        </Button>
      ),
    },
    delete: {
      title: 'DELETE',
      render: (text, record) => (
        <DeleteButton id={record._id} record={record} itemType="Session" deleteFunc="deleteSession" />
      ),
    },
  };

  // Result list of columns to display
  const res = [];

  // Push only the requested columns (showCols) end return
  for (let i = 0; i < showCols.length; i += 1) {
    const colName = showCols[i];
    res.push(cols[colName]);
  }

  return res;
};

export const SessionsTable = ({
  sessions, showCols, onEdit, pagination,
}) => (
  <Table
    rowKey={record => record._id}
    columns={columns({ onEdit, showCols })}
    dataSource={sessions}
    pagination={pagination}
  />
);

SessionsTable.propTypes = {
  sessions: PropTypes.arrayOf(propType(sessionFragment)).isRequired,
  showCols: PropTypes.arrayOf(PropTypes.string),
  onEdit: PropTypes.func,
  pagination: PropTypes.shape({
    defaultPageSize: PropTypes.number,
  }),
};

SessionsTable.defaultProps = {
  onEdit: () => {},
  pagination: { defaultPageSize: 10 },
};

export default SessionsTable;



// WEBPACK FOOTER //
// ./src/components/common/SessionsTable/index.js